<template>
  <div id="admins">
    <Navbar current="Administradores" />
    <Sidebar />
    <Container col="col-12">
      <!-- btnIcon="fa-solid fa-circle-plus" -->
      <Header
        title="Administradores"
        :btnLink="$paths.admins.add"
        btnLabel="Adicionar"
        btnIcon="fa-solid fa-plus-circle"
        icon="fa-solid fa-user-shield"
        :count="totalItemsRegistered"
        subtitle="Registro de todos os administradores"
      />
      <div class="card">
        <SearchBar v-if="totalItemsRegistered > 0" @onSearch="search" />
        <LoadingContainer v-if="loadingItems" />
        <div v-else>
          <EmptyState
            v-if="!items.length"
            :totalItemsRegistered="totalItemsRegistered"
            icon="fa-solid fa-user-shield"
            title="Nenhum administrador encontrado"
          >
            <template v-slot:noItemsRegistered></template>
          </EmptyState>
          <div v-else class="table-responsive">
            <table
              class="
                table table-sm table-nowrap
                card-table
                table-hover
                cursor-pointer
              "
            >
              <TableHead :columns="columns" v-on:sort="sort" />

              <tbody class="list">
                <router-link
                  tag="tr"
                  v-for="(item, index) in items"
                  v-bind:key="'tr-' + index"
                  :to="`${$paths.admins.detail}/${item.id}`"
                >
                  <td>{{ item.name }}</td>
                  <td>{{ item.email }}</td>
                  <td class="text-end">
                    <time>{{
                      $moment(item.created_at).format("DD/MM/YYYY")
                    }}</time>
                  </td>
                </router-link>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="row" v-if="!loadingItems">
        <div class="col-12 text-end">
          <span class="text-muted"
            >mostrando <b>{{ countItemsShowing }}</b> de
            <b>{{ countItemsTotal }}</b> resultado(s)</span
          >
        </div>
      </div>
      <div
        class="row justify-content-center"
        v-if="!loadingItems && moreItemsToLoad"
      >
        <div class="col-2">
          <FormButton
            label="Carregar mais"
            :loading="loadingMoreItems"
            @onClick="loadMore"
          />
        </div>
      </div>
    </Container>
  </div>
</template>
<script>
import AdminsController from "./AdminsController";
export default AdminsController;
</script>
